import { ThemeOptions } from '@mui/material';
import { MuiAlert } from '../../components/Alert/alert-overrides';
import { MuiAvatar } from '../../components/Avatar/avatar-overrides';
import { getMuiButton } from '../../components/Button/button-overrides';
import { MuiCheckbox } from '../../components/Checkbox/checkbox-overrides';
import { MuiChip } from '../../components/Chip/chip-overrides';
import { MuiDateCalendar } from '../../components/DateTimePicker/overrides/date-calendar-overrides';
import { MuiDateRangeCalendar } from '../../components/DateTimePicker/overrides/date-range-calendar-overrides';
import { getMuiDateRangePickerDay } from '../../components/DateTimePicker/overrides/date-range-picker-day-overrides';
import { MuiPickersCalendarHeader } from '../../components/DateTimePicker/overrides/pickers-calendar-header-overrides';
import { getMuiPickersDay } from '../../components/DateTimePicker/overrides/pickers-day-overrides';
import { MuiPickersPopper } from '../../components/DateTimePicker/overrides/pickers-popper-overrides';
import { MuiDrawer } from '../../components/Drawer/drawer-overrides';
import { MuiIconButton } from '../../components/IconButton/icon-button-overrides';
import { MuiMenu } from '../../components/Menu/menu-overrides';
import { MuiMenuItem } from '../../components/Menu/menuitem-overrides';
import { MuiDialog, MuiDialogTitle } from '../../components/Modal/modal-overrides';
import { MuiAutocomplete } from '../../components/MultiSelect/multiselect-overrides';
import { MuiPopover } from '../../components/Popover/popover-overrides';
import { MuiRadio } from '../../components/RadioGroup/radio-overrides';
import { MuiSelect } from '../../components/SimpleSelect/simpleselect-overrides';
import { MuiStack } from '../../components/Stack/stack-overrides';
import { getMuiSwitch } from '../../components/Switch/switch-overrides';
import { MuiTab, MuiTabs } from '../../components/TabGroup/tabgroup-overrides';
import { MuiTextField } from '../../components/TextField/textfield-overrides';
import { MuiToggleButton } from '../../components/ToggleButtonGroup/togglebutton-overrides';
import { MuiToggleButtonGroup } from '../../components/ToggleButtonGroup/togglebuttongroup-overrides';
import { MuiTooltip } from '../../components/Tooltip/tooltip-overrides';
import { MuiTypography } from '../../components/Typography/typography-overrides';
import { GetThemeOptions } from '../theme';
import { MuiBreadcrumbs } from './breadcrumb-overrides';
import { MuiButtonGroup } from './button-group';
import { MuiFab } from './fab';
import { MuiFormControl } from './form-control';
import { MuiFormHelperText } from './form-helper-text';
import { MuiFormLabel } from './form-label';
import { MuiInputBase } from './input-base';
import { MuiInputLabel } from './input-label';
import { MuiLink } from './link';
import { MuiListSubheader } from './list-subheader';
import { MuiMultiSectionDigitalClockSection } from './multi-section-digital-clock-overrides';
import { MuiOutlinedInput } from './outlined-input';
import { MuiPaper } from './paper';
import { MuiTable } from './table';
import { MuiTableCell } from './table-cell';
import { MuiTablePagination } from './table-pagination';
import { MuiTableRow } from './table-row';

/**
 * Style and default props overrides for MUI components used by our themes.
 */
export const getComponents = (opts: GetThemeOptions): ThemeOptions['components'] => ({
  MuiAlert,
  MuiAutocomplete,
  MuiAvatar,
  MuiBreadcrumbs,
  MuiButton: getMuiButton(opts),
  MuiButtonGroup,
  MuiCheckbox,
  MuiChip,
  MuiDateCalendar,
  MuiDateRangeCalendar,
  MuiDateRangePickerDay: getMuiDateRangePickerDay(opts),
  MuiDialog,
  MuiDialogTitle,
  MuiDrawer,
  MuiFab,
  MuiFormControl,
  MuiFormHelperText,
  MuiFormLabel,
  MuiIconButton,
  MuiInputBase,
  MuiInputLabel,
  MuiLink,
  MuiListSubheader,
  MuiMenu,
  MuiMenuItem,
  MuiMultiSectionDigitalClockSection,
  MuiOutlinedInput,
  MuiPaper,
  MuiPickersCalendarHeader,
  MuiPickersDay: getMuiPickersDay(opts),
  MuiPickersPopper,
  MuiPopover,
  MuiRadio,
  MuiSelect,
  MuiStack,
  MuiSwitch: getMuiSwitch(opts),
  MuiTab,
  MuiTable,
  MuiTableCell,
  MuiTablePagination,
  MuiTableRow,
  MuiTabs,
  MuiTextField,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiTooltip,
  MuiTypography,
});
